export const getActiveDotIndex = (intersectingIndices, currentPageSize, totalItems) => {
  const pageCounts = new Map();
  for (const idx of intersectingIndices) {
    const page = Math.floor(idx / currentPageSize);
    pageCounts.set(page, (pageCounts.get(page) || 0) + 1);
  }
  let activePage = 0;
  let maxRatio = 0;
  for (const [page, count] of pageCounts) {
    const pageItemCount = totalItems != null
      ? Math.min(currentPageSize, Math.max(0, totalItems - page * currentPageSize))
      : currentPageSize;
    const ratio = count / pageItemCount;
    if (ratio > maxRatio || (ratio === maxRatio && page > activePage)) {
      maxRatio = ratio;
      activePage = page;
    }
  }
  return activePage;
};
